module.exports = __webpack_public_path__ + "img/review.16889f30.svg";